import React from "react";

const HomeAdmin = () => {
  return (
    <div>Welcome Super Admin click on orders to work on clients' orders</div>
  );
};

export default HomeAdmin;
